import requestApi from "@/utils/requestApi";
import NListGenerato from "@nxin/nxin-ui-pc/NListGenerato/NListGenerato.vue";
import contract_sign from "@/views/order/orderDialog/contractSign.vue";

const { VUE_APP_OBLIGATION } = process.env;

export default {
  components: {
    contract_sign,
    nListGenerato: NListGenerato,
  },
  data() {
    return {
      form: {
        orderId: "",
        orgIdList: [],
        shopIdList: [],
        invoiceStatus: "",
      },
      theadData: [
        {
          prop: "purchaseOrgName",
          label: "买家",
          width: 150,
        },
        {
          prop: "fundShopName",
          label: "供应商",
          width: 180,
        },
        {
          prop: "settlementAmount",
          label: "可用授信额度",
          width: 110,
        },
        {
          prop: "settlementCn",
          label: "结算账期",
          width: 110,
        },
        {
          prop: "settlementDayCn",
          label: "最后付款日",
          width: 140,
        },
        {
          prop: "purchase",
          label: "采购订单",
          headerAlign: "center",
          children: [
            {
              prop: "purchaseOrderId",
              label: "订单号",
              width: 160,
            },
            {
              prop: "purchaseOrderStatusCn",
              label: "订单状态",
            },
            {
              prop: "purchaseFMoney",
              label: "订单金额",
            },
            {
              prop: "purchaseGoodsName",
              label: "商品",
              width: 200,
            },
            {
              prop: "purchaseUnitCn",
              label: "计量单位",
            },
            {
              prop: "purchaseGoodsQuantity",
              label: "数量",
            },
            {
              prop: "purchaseContractList",
              label: "电子合同",
              type: "custom",
            },
            {
              prop: "purchaseInvoiceStatusCn",
              label: "开票状态",
            },
          ],
        },
        {
          prop: "sale",
          label: "关联销售订单",
          headerAlign: "center",
          children: [
            {
              prop: "saleOrderId",
              label: "订单号",
              width: 160,
            },
            {
              prop: "saleOrderStatusCn",
              label: "订单状态",
            },
            {
              prop: "saleFMoney",
              label: "订单金额",
            },
            {
              prop: "saleGoodsName",
              label: "商品",
              width: 200,
            },
            {
              prop: "saleUnitCn",
              label: "计量单位",
            },
            {
              prop: "saleGoodsQuantity",
              label: "数量",
            },
            {
              prop: "saleContractList",
              label: "电子合同",
              type: "custom",
            },
          ],
        },
        {
          prop: "fn",
          fixed: "right",
          label: "操作",
          headerAlign: "center",
          type: "custom",
        },
      ],
      tbodyData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchData: [
        {
          tag: "input",
          prop: "orderId",
          value: "",
          label: "采购订单",
          placeholder: "请输入订单号",
        },
        {
          tag: "select",
          prop: "orgIdList",
          value: "",
          label: "买家",
          options: [],
          multiple: true,
          placeholder: "支持搜索/多选/默认全部",
        },
        {
          tag: "select",
          prop: "shopIdList",
          value: [],
          label: "供应商",
          options: [],
          multiple: true,
          placeholder: "支持搜索/多选/默认全部",
        },
        {
          tag: "select",
          prop: "invoiceStatus",
          value: "",
          label: "开票状态",
          options: [
            {
              value: "WSQ",
              label: "未申请",
            },
            {
              value: "CS",
              label: "未开票",
            },
            {
              value: "PROCESS",
              label: "开票中",
            },
            {
              value: "SUCCESS",
              label: "已开票",
            },
          ],
          placeholder: "请选择",
        },
      ],
      buttonFunctionData: [
        {
          tag: "button",
          icon: "el-icon-download",
          prop: "export",
          type: "primary",
          label: "导出",
        },
      ],
      payData: {},
      payVisible: false,
    };
  },

  created() {
    const body = document.querySelector("body");
    body.classList.add("seller-style");
  },

  async mounted() {
    const [orgIdListRes, shopIdListRes] = await Promise.all([
      requestApi.post(`sctrading/shop/selSelfOrgList`, {}),
      requestApi.post(`sctrading/shop/selShopList`, {}),
    ]);
    this.searchData[1].options = orgIdListRes.data.map((item) => ({
      ...item,
      label: item.name,
      value: item.id,
    }));

    const index = orgIdListRes.data.findIndex((item) => item.id == VUE_APP_OBLIGATION);
    if (index != -1) {
      this.searchData[1].value = [VUE_APP_OBLIGATION];
      this.form.orgIdList = [VUE_APP_OBLIGATION];
    }
    this.searchData[2].options = shopIdListRes.data.map((item) => ({
      ...item,
      label: item.name,
      value: item.shopId,
    }));
    this.loadData();
  },

  methods: {
    async loadData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { msg, code, data } = await requestApi.post(`sctrading/order/purchase/needPayPage`, {
        ...this.form,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      });
      loading.close();

      if (code == "0") {
        this.total = Number(data.total);
        if (data.list.length == 0 && this.pageNum > 1) {
          this.pageNum = 1;
          this.loadData();
        } else {
          this.tbodyData = data.list;
        }
      } else {
        this.$message.error(msg);
      }
    },

    sizeChange(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.loadData();
    },
    currentChange(value) {
      if (typeof value === "number") {
        this.pageNum = value;
        this.loadData();
      }
    },

    resetForm() {
      this.$refs.form.resetFields();
    },
    searchSubmit(form) {
      console.log("form", form);
      this.form = form;
      this.pageNum = 1;
      this.loadData();
    },

    async handleExport() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { msg, code, data } = await requestApi.post(`sctrading/order/purchase/needPay/export`, this.form);
      loading.close();

      if (code == "0") {
        this.$open(data.url, { target: 1 });
      } else {
        this.$message.error(msg);
      }
    },
    contractView(contract, type) {
      this.$refs.contract_sign_dialog.viewContract({ orderId: type == "purchaseContractList" ? contract.row.purchaseOrderId : contract.row.saleOrderId });
    },
    // 合并行
    tableSpanMethod({ row, column, rowIndex }) {
      const { tbodyData } = this;
      const purchaseOrderIdMerge = ["purchaseOrderId", "purchaseOrderStatusCn", "purchaseFMoney", "purchaseContractList", "fn"];
      const saleOrderIdMerge = ["saleOrderId", "saleFMoney", "saleOrderStatusCn", "saleContractList"];
      const saleOrderIdPurchaseOrgNameMerge = ["purchaseOrgName", "settlementAmount", "settlementCn", "settlementDayCn"];
      const saleOrderIdFundShopNameMerge = ["fundShopName"];
      if (purchaseOrderIdMerge.includes(column.property)) {
        let rowspan = 1;
        let colspan = 1;
        if (rowIndex) {
          let indexUp = rowIndex - 1;
          if (tbodyData[indexUp] && row.purchaseOrderId == tbodyData[indexUp].purchaseOrderId) {
            rowspan = 0;
            colspan = 0;
          } else {
            let index = rowIndex + 1;
            rowspan = 1;
            colspan = 1;
            while (tbodyData[index] && row.purchaseOrderId == tbodyData[index].purchaseOrderId) {
              index++;
              rowspan++;
            }
          }
        } else {
          let index = rowIndex + 1;
          while (tbodyData[index] && row.purchaseOrderId == tbodyData[index].purchaseOrderId) {
            index++;
            rowspan++;
          }
        }

        return {
          rowspan,
          colspan,
        };
      } else if (saleOrderIdMerge.includes(column.property)) {
        let rowspan = 1;
        let colspan = 1;
        if (rowIndex) {
          let indexUp = rowIndex - 1;
          if (tbodyData[indexUp] && row.saleOrderId && row.saleOrderId == tbodyData[indexUp].saleOrderId) {
            rowspan = 0;
            colspan = 0;
          } else {
            let index = rowIndex + 1;
            rowspan = 1;
            colspan = 1;
            while (tbodyData[index] && row.saleOrderId && row.saleOrderId == tbodyData[index].saleOrderId) {
              index++;
              rowspan++;
            }
          }
        } else {
          let index = rowIndex + 1;
          while (tbodyData[index] && row.saleOrderId && row.saleOrderId == tbodyData[index].saleOrderId) {
            index++;
            rowspan++;
          }
        }

        return {
          rowspan,
          colspan,
        };
      } else if (saleOrderIdPurchaseOrgNameMerge.includes(column.property)) {
        let rowspan = 1;
        let colspan = 1;
        if (rowIndex) {
          let indexUp = rowIndex - 1;
          if (tbodyData[indexUp] && row.saleOrderId == tbodyData[indexUp].saleOrderId && row.purchaseOrgName == tbodyData[indexUp].purchaseOrgName) {
            rowspan = 0;
            colspan = 0;
          } else {
            let index = rowIndex + 1;
            rowspan = 1;
            colspan = 1;
            while (tbodyData[index] && row.saleOrderId == tbodyData[index].saleOrderId && row.purchaseOrgName == tbodyData[index].purchaseOrgName) {
              index++;
              rowspan++;
            }
          }
        } else {
          let index = rowIndex + 1;
          while (tbodyData[index] && row.saleOrderId == tbodyData[index].saleOrderId && row.purchaseOrgName == tbodyData[index].purchaseOrgName) {
            index++;
            rowspan++;
          }
        }

        return {
          rowspan,
          colspan,
        };
      } else if (saleOrderIdFundShopNameMerge.includes(column.property)) {
        let rowspan = 1;
        let colspan = 1;
        if (rowIndex) {
          let indexUp = rowIndex - 1;
          if (tbodyData[indexUp] && row.saleOrderId == tbodyData[indexUp].saleOrderId && row.fundShopName == tbodyData[indexUp].fundShopName) {
            rowspan = 0;
            colspan = 0;
          } else {
            let index = rowIndex + 1;
            rowspan = 1;
            colspan = 1;
            while (tbodyData[index] && row.saleOrderId == tbodyData[index].saleOrderId && row.fundShopName == tbodyData[index].fundShopName) {
              index++;
              rowspan++;
            }
          }
        } else {
          let index = rowIndex + 1;
          while (tbodyData[index] && row.saleOrderId == tbodyData[index].saleOrderId && row.fundShopName == tbodyData[index].fundShopName) {
            index++;
            rowspan++;
          }
        }

        return {
          rowspan,
          colspan,
        };
      }
    },
    toPay() {
      const { payData } = this;
      this.payVisible = false;
      window.open(`${process.env.VUE_APP_APP}payment/chectout/bkCheckout/${payData.purchaseOrderId}`);
    },
    toPayDialog(row) {
      this.payData = row;
      this.payVisible = true;
    },
  },
};
